import React from 'react';
import { Route } from 'react-router-dom';
import { AllRouteConstants } from '../../../router/routes';
import { Plan } from '../pages';
import { useAppSelector } from '../../../hooks/useAppSelector';
import Redirect from '../../../HoC/Redirect';

const PlanRoutes = () => {
	const { mode } = useAppSelector((state) => state.cachedReducer);

	return mode === 'real' ? (
		<>
			<Route path={AllRouteConstants.user.plan} element={<Plan />} />
		</>
	) : (
		<>
			<Route
				path={AllRouteConstants.user.plan}
				element={<Redirect path={AllRouteConstants.user.home} />}
			/>
		</>
	);
};

export default PlanRoutes;
